import { createFileRoute } from "@tanstack/react-router";
import {
  SpringsLandingPage,
  buildSpringsLandingHead,
} from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-seo-monument");

export const Route = createFileRoute("/colorado-springs-seo-monument")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
